module.exports = function() {
  return new Worker(__webpack_public_path__ + "f783f0f8575746494761.worker.js");
};